import { render, staticRenderFns } from "./SyllableSlider.vue?vue&type=template&id=7c694c9b&lang=html"
import script from "./SyllableSlider.vue?vue&type=script&lang=js"
export * from "./SyllableSlider.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports